import React from 'react';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';
import WelcomeMessage from './WelcomeMessage';
import { useAutoScroll } from '../../../hooks';

const ChatMessages = ({
  chatLog,
  isLoading,
  conversationMessages = [],
  welcomeMessage = 'How can I help you today?',
  onActionClick,
}) => {
  // Merge conversation history with current chat log
  // Priority: conversation messages (loaded from history) + current session messages
  const messagesToDisplay = conversationMessages.length > 0 
    ? [...conversationMessages, ...chatLog]
    : chatLog;
    
  const scrollRef = useAutoScroll([messagesToDisplay, isLoading]);

  return (
    <main className="chat-messages">
      <div className="messages-container">
        {messagesToDisplay.length === 0 ? (
          <WelcomeMessage message={welcomeMessage} />
        ) : (
          <>
            {messagesToDisplay.map((message, index) => (
              <MessageBubble key={index} message={message} onActionClick={onActionClick} />
            ))}
            {isLoading && <TypingIndicator />}
          </>
        )}
        <div ref={scrollRef}></div>
      </div>
    </main>
  );
};

export default ChatMessages;
